'use strict';

import {localDataStorageProvider} from "../services/localdatastorageprovider.js";

export class ReportsListCtrl
{
	storageNames = {
		columns: 'ReportsListCtrlColumns',
		query: 'ReportsListCtrlQuery'
	};
	
	columnsData = {
		columns: {}
	};
	resultOptions = {
		boundaryLinks: false,
		limitSelect: true,
		pageSelect: true
	};
	limitOptions = [10, 20, 30, 40, 50, 100, 200];
	query = {
		order: '',
		limit: 20,
		page: 1,
		filters: {}
	};
	defaultQuery = {
		order: '',
		limit: 20,
		page: 1,
		filters: {}
	};
	
	classif = {};
	typeSettings = {};
	chips = [];
	promise;
	
	data = [];
	total = 0;
	initialized = false;
	
	$filter;
	$scope;
	notify;
	jsDataService;
	$http;
	$mdDialog;
	
	cfg = {
		procedureRegister: {}
	};
	massStatusId = '';
	massTypeId = '';
	selectedRows = [];
	
	constructor($scope, $filter, $http, $mdDialog, $httpParamSerializerJQLike, jsDataService, notify){
		'ngInject';
		this.$filter = $filter;
		this.$scope = $scope;
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.typeSettings = this.jsDataService.get('typeSettings', {});
		this.cfg.procedureRegister = this.jsDataService.get('cfgProcedureRegister', {});
	}
	
	$onInit(){
		this.initColumns();
		this.initQuery();
		this.initialized = true;
//		this.loadData();
	}
	
	initColumns(){
		const params = ['show'];
		const primaryData = this.jsDataService.get('cfgDisplayColumns', {});
		const tiny = this.getTinyDataForStorage(primaryData, params);
		const stored = new localDataStorageProvider(this.storageNames.columns, {columns: tiny});
		let storedData = stored.getData();
		if(typeof(storedData) !== 'undefined' && typeof(storedData.columns) !== 'undefined'){
			for(let i in storedData.columns){
				if(typeof(primaryData[i]) === 'undefined'){
					delete storedData.columns[i];
				}
			}
		}
		this.columnsData = angular.merge({}, {columns: primaryData}, storedData);
		const self = this;
		this.$scope.$watch(function(){
			return angular.toJson(self.columnsData);
		},function(){
			const col = self.getTinyDataForStorage(self.columnsData.columns, params);
			stored.setData({columns: col});
		});
	}
	
	initQuery(){
		const params = ['value'];
		this.defaultQuery = angular.merge({}, this.getDefaultQuery(), this.jsDataService.get('cfgQuery', {}));
		const tiny = this.getTinyDataForStorage(this.defaultQuery.filters, params);
		let storing = angular.copy(this.defaultQuery);
		storing.filters = tiny;
		const stored = new localDataStorageProvider(this.storageNames.query, storing);
		this.query = angular.merge({}, this.defaultQuery, stored.getData());
		const self = this;
		this.$scope.$watch(function(){
			return angular.toJson(self.query);
		},function(){
			let toStore = angular.copy(self.query);
			toStore.filters = self.getTinyDataForStorage(toStore.filters, params);
			stored.setData(toStore);
			self.setChips();
			self.loadData();
		});
		
	}
	
	isFilters(){
		var o = angular.copy(this.query.filters);
		var d = angular.copy(this.defaultQuery.filters);
//		delete o.query;
//		delete d.query;
		if(angular.equals(o, d)){
			return false;
		}
		return true;
	}
	
	getFilterChips(){
		let chips = [];
		for(let i in this.query.filters){
			if(this.query.filters[i].isChip && this.query.filters[i].value && this.query.filters[i].value != this.defaultQuery.filters[i].value){
				chips.push({
					key: i,
					field: this.query.filters[i].field,
					title: this.query.filters[i].title,
					value: this.getChipValue(this.query.filters[i])
				});
			}
		}
		return chips;
	}
	
	getChipValue(field){
		let classifName = (typeof(field.classifName) !== 'undefined') ? field.classifName : field.field;
		if(field.type === 'classif' && typeof(this.classif[classifName]) !== 'undefined'){
			let val = this.$filter('filter')(this.classif[classifName], {id: field.value}, true);
			if(val.length > 0){
				return val.shift().title;
			}
			else{
				return null;
			}
		}
		else if(field.type === 'datepicker' && typeof(field.value) !== 'undefined' && field.value !== ''){
			let format = 'yyyy-MM-dd';
			return this.$filter('date')(field.value, format);
		}
		else{
			return field.value;
		}
	}
	
	getCustomClasssifValue(field, defaultValue){
		let val = this.getChipValue(field);
		if((null === val || val === '') && defaultValue){
			return defaultValue;
		}
		return val;
	}
	
	setChips(){
		this.chips = this.getFilterChips();
	}
	
	removeChip(chip){
		this.chips = [];
		if(typeof(this.query.filters[chip.key]) !== 'undefined'){
//			this.clearFilterField(this.query.filters[chip.key]);
			this.clearFilterKey(chip.key);
		}
		const self = this;
		setTimeout(function(){
			self.setChips();
		}, 20);
	}
	
	clearFilterField(filterField){
		filterField.value = '';
	}
	
	clearFilterKey(key){
		if(typeof(this.query.filters[key]) !== 'undefined'){
			if(typeof(this.defaultQuery.filters[key]) !== 'undefined'){
				this.query.filters[key].value = this.defaultQuery.filters[key].value;
			}
			else{
				this.query.filters[key].value = '';
			}
		}
	}
	
	clearFilters(){
		this.query.filters = angular.copy(this.getDefaultQuery().filters);
	}
	
	getDefaultQuery(){
		return this.defaultQuery;
	}
	
	getActiveColumns(){
		return this.$filter('filter')(Object.values(this.columnsData.columns), {show: true}, true)
			.map(col => {
				col.title = col.title.replace(' ', '<br>')
				return col;
			});
	}
	
	columnSort(col){
		if(col.sort){
			return col.key;
		}
		return null;
	}
	
	getColValue(row, col){
		let dateFilterFormat = 'yyyy-MM-dd';
		switch(col){
			case 'created':
			case 'updated':
				if(row[col] == 0){
					return '';
				}
				return this.$filter('u2date')(row[col], dateFilterFormat);
			case 'status':
				if(typeof(row[col+'_title']) !== 'undefined'){
					return row[col+'_title'];
				}
				return '';
			case 'send':
				if(typeof(row[col+'_title']) !== 'undefined'){
					return row[col+'_title'];
				}
				return '';
			case 'important':
				if(typeof(arguments[2]) !== 'undefined' && typeof(row[col+'_title']) !== 'undefined'){
					return row[col+'_title'];
				}
				return '';

		}
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		return row[col];
	}
	
	loadData(){
		if(this.initialized){
			const url = this.jsDataService.get('cfgDataUrl');
			if(url){
				const self = this;
				this.promise = this.$http({
					url: url,
					method: 'GET',
					params: this.query
				}).then(function(response){
					if(response.data.success){
						self.data = response.data.data;
						self.total = response.data.total;
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}, function(response){
					console.log("HTTP ERROR");
					console.log(response);
				});
			}
		}
	}
	
	getTinyDataForStorage(obj, param){
		let outp = {};
		for(let i in obj){
			outp[i] = {};
			for(let k of param){
				if(typeof(obj[i][k]) !== 'undefined'){
					outp[i][k] = obj[i][k];
				}
			}
		}
		return outp;
	}
	
	actionCall(e, action, item){
//		console.log('call', action, item.actions[action]);
		if(action == 'remove'){
			this.removeItem(e, item);
		}

		else{
			window.location.href = item.actions[action].href;
		}
	}
	
	removeItem(e, item){
		const url = item.actions.remove.href;
		if(url){
			const ctrl = this;
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			let confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.textContent(this.varReplace(confirmTexts.content, item))
				.ariaLabel(confirmTexts.title)
				.targetEvent(e)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);

			this.$mdDialog.show(confirm).then(function () {
				ctrl.$http({
					url: url,
					method: 'GET',
					responseType: 'json'
				}).then(function(response){
					if(response.data){
						ctrl.loadData();
						if(response.data.message){
							ctrl.notify(response.data.message, !response.data.success);
						}
					}
					else{
						ctrl.notify('Communication Error', true);
					}
				}, function(response){
					console.log("HTTP ERROR");
					console.log(response);
					ctrl.notify('Network error, Status: ' + response.status, true);
					ctrl.newdocumentSubmitted = false;
				});
			}, function () {});
		}
		else{
			this.notify('Undefined URL', true);
		}
	}
	
	procRegister(e){
		if(this.cfg.procedureRegister.url){
			location.href = this.cfg.procedureRegister.url;
		}
	}
	
	varReplace(text, params){
		for(let i in params){
			let reg = new RegExp("\\{"+i+"\\}", "i");
			text = text.replace(reg, params[i]);
		}
		return text;
	}
	
	getLevelArray(level){
		if(isNaN(level)){
			return [];
		}
		let lev = parseInt(level) - 1;
		if(lev < 1){
			return [];
		}
		return [].constructor(lev);
	}
	
	getFilteredClassif(classifName, filterField, filterValue){
		if(typeof(this.classif[classifName]) === 'undefined'){
			return [];
		}
		if(filterValue && filterValue > 0){
			let filterParams = {};
			filterParams[filterField] = filterValue;
			return this.$filter('filter')(this.classif[classifName], filterParams, true);
		}
		return [];
	}
	
	unsetProperty(prop){
		if(typeof(prop.value) !== 'undefined'){
			prop.value = '';
			this.setChips();
		}
	}
	
	massChangeStatus(e){
		if(this.initialized){
			const url = this.jsDataService.get('massStatusChangeUrl');
			if(url){
				let ids = [];
				for(let r of this.selectedRows){
					ids.push(r.id);
				}
				const self = this;
				this.promise = this.$http({
					url: url,
					method: 'POST',
					data: {
						newstatus: self.massStatusId,
						newtype: self.massTypeId,
						ids: ids
					}
				}).then(function(response){
					if(response.data.success){
						self.selectedRows = [];
						self.massStatusId = '';
						self.massTypeId = '';
						self.loadData();
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}, function(response){
					console.log("HTTP ERROR");
					console.log(response);
					self.notify('Network error, Status: ' + response.status, true);
				});
			}
		}
	}
	
	deselectRow(row){
		this.selectedRows = this.$filter('filter')(this.selectedRows, {id: '!' + row.id}, true);
	}
	
	disabledSelection(row){
		return false;
	}

	changeImportant(item){
		if(this.initialized){
			const url = this.jsDataService.get('importantUrl');
			if(url){
				const self = this;
				this.promise = this.$http({
					url: url,
					method: 'POST',
					data: {
						id: item.id,
						important: !item.important
					}
				}).then(function(response){
					if(response.data.success){
						item.important = response.data.important;
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}, function(response){
					console.log("HTTP ERROR");
					console.log(response);
				});
			}
		}
	}
	
	massChangeDisabled(){
		return (!this.massStatusId && !this.massTypeId);
	}

	resetOrderDefault(){
		this.query.order = 'default';
	}

	isOrderDefault(){
		return (this.query.order === 'default');
	}

	dataExport(e){
		if(this.jsDataService.get('dataExportUrl') !== ''){
//			console.log()
			location.href = this.jsDataService.get('dataExportUrl')  + "?"+ this.$httpParamSerializerJQLike(this.query)+'&columns='+encodeURIComponent(angular.toJson(this.getActiveColumns()));
//			location.href = this.jsDataService.get('dataExportUrl')  + "?filters="+ encodeURIComponent(angular.toJson(this.query));

		}
	};

	massRemoveItems(e){
		if(this.initialized){
			const url = this.jsDataService.get('massRemoveUrl');
			if(url){
				let ids = [];
				for(let r of this.selectedRows){
					ids.push(r.id);
				}
				const self = this;
				this.promise = this.$http({
					url: url,
					method: 'POST',
					data: {
						ids: ids
					}
				}).then(function(response){
					if(response.data.success){
						self.selectedRows = [];
						self.massStatusId = '';
						self.massTypeId = '';
						self.loadData();
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}, function(response){
					console.log("HTTP ERROR");
					console.log(response);
					self.notify('Network error, Status: ' + response.status, true);
				});
			}
		}
	}
}
